import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../assets/thumbs-up-green.svg'


const _hoisted_1 = { class: "result-success item-font" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = { class: "item-secondary-title pt-2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, [
      _createTextVNode(" Your application has been successful"),
      (!_ctx.withAmendments)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "!"))
        : _createCommentVNode("", true),
      (_ctx.withAmendments)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, " with amendments"))
        : _createCommentVNode("", true)
    ])
  ]))
}